import { render, staticRenderFns } from "./DialogoCompensacao.vue?vue&type=template&id=2d39e93a&scoped=true&"
import script from "./DialogoCompensacao.vue?vue&type=script&lang=js&"
export * from "./DialogoCompensacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39e93a",
  null
  
)

export default component.exports